import { useState, useEffect, useContext } from 'react'
import { getSessionStorageCurrencyUpdatedKey } from '../utils'
import {
  setCurrencyAndPopIn,
  matchCurrencyCode,
} from '../components/CurrencyConverterSwitcher'
import { LayoutContext } from '../contexts'
import { useShopify } from '../contexts/shopify'

const useCurrencyHydration = () => {
  const { storeSubdomain, node_locale } = useContext(LayoutContext)
  const { setCurrencyPopIn } = useShopify()

  const sessionStorageCurrencyUpdated = JSON.parse(
    sessionStorage.getItem(getSessionStorageCurrencyUpdatedKey(storeSubdomain)),
  )

  const [[country, localCurrency], setState] = useState([null, null])

  const fetchGeoIp = async () => {
    const url = 'https://get.geojs.io/v1/ip/country.json'
    try {
      const response = await fetch(url)
      const data = await response.json()
      matchCurrencyCode(data.country, setState)
    } catch (error) {
      matchCurrencyCode('NL', setState)
      console.error(error)
    }
  }

  useEffect(() => {
    if (!localCurrency) {
      fetchGeoIp()
    }

    if (localCurrency && node_locale && country) {
      setCurrencyAndPopIn(
        localCurrency,
        node_locale,
        country,
        setCurrencyPopIn,
        sessionStorageCurrencyUpdated,
      )
    }
  }, [localCurrency, country, node_locale])
}

export default useCurrencyHydration
